import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import * as AC from "../actionCreators";

export type State = boolean;

const initialState: State = false;

const allFiltersFetchingReducer = reducer(
  initialState,
  on(AC.userFilterGetAllFiltersRequest, (state, { payload }) => true),
  on(
    AC.userFilterGetAllFiltersSuccess,
    AC.userFilterGetAllFiltersError,
    (state, { payload }) => false
  )
);

export default allFiltersFetchingReducer;
export type AllFiltersFetching = State;
